module.exports = __webpack_public_path__ + "i18n/languages.d048a81.json";